import { render } from "./ResultsList.vue?vue&type=template&id=6add9c09&scoped=true"
import script from "./ResultsList.vue?vue&type=script&lang=js"
export * from "./ResultsList.vue?vue&type=script&lang=js"

import "./ResultsList.vue?vue&type=style&index=0&id=6add9c09&lang=scss"
import "./ResultsList.vue?vue&type=style&index=1&id=6add9c09&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2874961510/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6add9c09"]])

export default __exports__